class SearchTwoIntReq {
  constructor() {
    this.ParentSessionId = undefined;
    this.ContractId = undefined;
  }
}

export default SearchTwoIntReq;
